// no local state needed

import { PriceIndexOrderDto } from '@eastcoal/api/trade/interface'
import { queryPriceIndexOrderPageApi } from '@eastcoal/api/trade/orderOperation/queryPriceIndexOrderPage'

import { RemoteTransfer } from '@eastcoal/common/components/RemoteTransfer'
import { round } from '@eastcoal/common/utils/decimal'

import { DateRangePicker } from '@eastcoal/formily/components/DatePicker'
import { Input } from '@eastcoal/formily/components/Input'
import { observer, useForm } from '@eastcoal/formily/exports/react'

import { PriceIndexPriceCalculatorTransferProps } from './interface'

const columns: PriceIndexPriceCalculatorTransferProps['leftColumns'] = [
  {
    dataIndex: 'dealDate',
    title: '日期',
    align: 'center'
  },
  {
    dataIndex: 'memberName',
    title: '公司',
    align: 'center'
  },
  {
    dataIndex: 'kindName',
    title: '品种',
    align: 'center'
  },
  {
    dataIndex: 'dealPrice',
    title: '价格',
    align: 'right',
    valueType: 'digit'
  },
  {
    dataIndex: 'dealQuantity',
    title: '数量',
    align: 'right',
    valueType: 'digit'
  },
  {
    dataIndex: 'calorificValue',
    title: '热值',
    align: 'right',
    valueType: 'digit'
  },
  {
    dataIndex: 'storagePlace',
    title: '存放地',
    align: 'center'
  }
]

const leftSearchForm: PriceIndexPriceCalculatorTransferProps['leftSearchForm'] =
  {
    name: 'PriceIndexPriceCalculatorTransferSearchForm',
    grid: {
      minWidth: 0,
      maxWidth: 100
    },
    schema: [
      {
        name: 'search',
        type: 'string',
        gridSpan: 2,
        'x-component': Input,
        'x-component-props': {
          placeholder: '请输入公司名称关键字'
        }
      },
      {
        name: '[startDate,endDate]',
        type: 'array',
        gridSpan: 3,
        'x-component': DateRangePicker,
        'x-component-props': {
          format: 'YYYY-MM-DD',
          placeholder: '请输入日期'
        }
      }
    ]
  }

export const PriceIndexPriceCalculator = observer((props: any) => {
  const form = useForm()
  const kindId = form.values.kindId

  // 本组件不在 effect 中重置本地 state；通过给 RemoteTransfer 设置 key 在 kind 变化时重置自身状态

  const handleChange = (value: PriceIndexOrderDto[]) => {
    const totalPrice = value.reduce(
      (prev, current) => prev + (current.totalPrice ?? 0),
      0
    )
    const totalQUantity = value.reduce(
      (prev, current) => prev + (current.dealQuantity ?? 0),
      0
    )
    const price = totalQUantity === 0 ? 0 : totalPrice / totalQUantity
    form.setValuesIn('price', round(price, { precision: 2 }))
  }

  return (
    <RemoteTransfer
      key={kindId ?? 'none'}
      api={queryPriceIndexOrderPageApi}
      height={500}
      leftColumns={columns}
      leftSearchForm={leftSearchForm}
      readyRequest={!!kindId}
      refreshDeps={[kindId]}
      rightColumns={columns}
      rowKey='id'
      showSearch={false}
      requestParams={{
        kindId,
        pageSize: '20'
      }}
      onChange={handleChange}
    />
  )
})
